import { IonButton, IonButtons, IonCard, IonCardHeader, IonCardTitle, IonContent, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface WelcomeScreenProps {
  onCreateGame: () => void;
  onJoinGame: () => void;
  onClose?: () => void;
}

const GameSetupIntro: React.FC<WelcomeScreenProps> = ({ onCreateGame, onJoinGame, onClose }) => {
  const { t } = useTranslation();

  return (
    <>
      <IonHeader className='ion-no-border'>
        <IonToolbar color="light">
          <IonButtons slot="start">
            {onClose && (
              <IonButton onClick={onClose}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            )}
          </IonButtons>
          <IonTitle>{t('create_round_of_golf')}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent color="light">
        <div className="flex flex-col justify-center md:flex-row md:flex-wrap">
          <IonCard className="relative overflow-hidden md:w-80 h-64 cursor-pointer mb-0" onClick={onCreateGame}>
            <img
              alt="Golf course"
              src="/assets/images/bg/play-game.webp"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/70"></div>
            <IonCardHeader className="absolute inset-x-0 bottom-0 text-white z-10 text-left">
              <p className="mt-1 text-white/90 text-sm">{t('create_round_of_golf_caption')}</p>
              <IonCardTitle className="text-white font-bold text-xl">{t('create_round_of_golf')}</IonCardTitle>
            </IonCardHeader>
          </IonCard>

          <IonCard className="relative overflow-hidden shadow-2xl md:w-80 h-64 cursor-pointer" onClick={onJoinGame}>
            <img
              alt="Scorecard"
              src="/assets/images/bg/scorecard.webp"
              className="absolute inset-0 w-full h-full object-cover grayscale brightness-75"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/70"></div>
            <p className="absolute top-2 right-2 text-xs text-amber-400 bg-amber-700/40 px-2 py-1 rounded-full mt-1">{t('coming_soon')}</p>
            <IonCardHeader className="absolute inset-x-0 bottom-0 text-white z-10 text-left">
              <p className="mt-1 text-white/90 text-sm">{t('add_score_caption')}</p>
              <IonCardTitle className="text-white font-bold text-xl">{t('add_score')}</IonCardTitle>
            </IonCardHeader>
          </IonCard>

          <IonCard className="hidden relative overflow-hidden shadow-2xl md:w-80 h-64 cursor-pointer" onClick={onJoinGame}>
            <img
              alt="Scorecard"
              src="/assets/images/bg/championship.webp"
              className="absolute inset-0 w-full h-full object-cover grayscale brightness-75"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/70"></div>
            <p className="absolute top-2 right-2 text-xs text-amber-400 bg-amber-700/40 px-2 py-1 rounded-full mt-1">{t('coming_soon')}</p>
            <IonCardHeader className="absolute inset-x-0 bottom-0 text-white z-10 text-left">
              <p className="mt-1 text-white/90 text-sm">{t('championship')}</p>
              <IonCardTitle className="text-white font-bold text-xl">{t('championship')}</IonCardTitle>
            </IonCardHeader>
          </IonCard>

        </div>
      </IonContent>
    </>
  );
};

export default GameSetupIntro;
